export default __webpack_public_path__ + "static/media/purpleBackground.1b54cbbb.svg";